import { takeLatest, call, put, select } from 'redux-saga/effects';
import axios from 'axios';
import {
  messagesListRequest,
  messagesListSuccess,
  messagesListFailure,
} from '../reducers/messagesList';
import { API_LINK } from '../../constants';

const API = `${API_LINK}api/user/`;

function* messagesListAxios() {
  
  const state = yield select(fullState => fullState);
  
  const userId = state.loginReducer.isTeamLeader
    ? state.teamMembersReducer.selectedTeamMemberId
    : state.loginReducer.user.userId;
   
  const { token } = state.loginReducer;

  const response = yield call(() =>
    axios({
      method: 'get',
      url: `${API}${userId}/message`,
      headers: {
        'Access-Control-Allow-Origin': '*',
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
        Authorization: `Bearer ${token}`,
      },
    }),
  );

  return response;
}

function* workerMessagesListSaga() {
  try {
    const response = yield call(messagesListAxios);

    const responseFromMessagesList = response.data;
    yield put(messagesListSuccess(responseFromMessagesList));
  } catch (error) {
    yield put(messagesListFailure(error));
  }
}

export function* watcherMessagesListSaga() {
  yield takeLatest(messagesListRequest().type, workerMessagesListSaga);
}
